export const FaceTecStrings = {
  "FaceTec_action_ok": "ACEPTAR",
  "FaceTec_action_im_ready": "ESTOY LISTO",
  "FaceTec_action_try_again": "INTENTAR NUEVAMENTE",
  "FaceTec_action_continue": "CONTINUAR",
  "FaceTec_action_take_photo": "TOMAR FOTO",
  "FaceTec_action_accept_photo": "ACEPTAR",
  "FaceTec_action_retake_photo": "VOLVER",
  "FaceTec_action_confirm": "CONFIRMAR INFORMACIÓN",

  "FaceTec_accessibility_cancel_button": "Cancelar",
  "FaceTec_accessibility_tap_guidance": "Toque dos veces cualquier parte de la pantalla para ver indicaciones sobre cómo alinear el rostro.",
  "FaceTec_accessibility_key_down_guidance": "Presione Entrar o la barra espaciadora para obtener orientación sobre la alineación de la cara",

  "FaceTec_accessibility_feedback_move_phone_away": "Su rostro está demasiado cerca",
  "FaceTec_accessibility_feedback_move_phone_closer": "Su rostro está demasiado lejos",
  "FaceTec_accessibility_feedback_face_too_far_left": "Su rostro está demasiado a la izquierda",
  "FaceTec_accessibility_feedback_face_too_far_right": "Su rostro está demasiado a la derecha",
  "FaceTec_accessibility_feedback_face_too_low": "Su rostro está demasiado abajo",
  "FaceTec_accessibility_feedback_face_too_high": "Su rostro está demasiado arriba",
  "FaceTec_accessibility_feedback_face_rotated_too_far_left": "Su rostro gira demasiado a la izquierda",
  "FaceTec_accessibility_feedback_face_rotated_too_far_right": "Su rostro gira demasiado a la derecha",
  "FaceTec_accessibility_feedback_face_looking_too_far_left": "Su rostro está demasiado inclinado hacia la izquierda",
  "FaceTec_accessibility_feedback_face_looking_too_far_right": "Su rostro está demasiado inclinado hacia la derecha",
  "FaceTec_accessibility_feedback_face_not_in_camera": "El rostro no se ve en la cámara o está demasiado lejos",
  "FaceTec_accessibility_feedback_hold_phone_to_eye_level": "Mantenga el dispositivo a la altura de los ojos",
  "FaceTec_accessibility_feedback_move_away_web": "Cámara demasiado cerca",
  "FaceTec_accessibility_feedback_move_closer_web": "Cámara demasiado lejos",
  "FaceTec_accessibility_feedback_hold_to_eye_level_web": "Mover la cámara al nivel de los ojos",

  "FaceTec_presession_frame_your_face": "Encuadra tu rostro en el óvalo",
  "FaceTec_presession_look_straight_ahead": "Mira hacia el frente",
  "FaceTec_presession_hold_steady3": "No te muevas durante: 3",
  "FaceTec_presession_hold_steady2": "No te muevas durante: 2",
  "FaceTec_presession_hold_steady1": "No te muevas durante: 1",
  "FaceTec_presession_eyes_straight_ahead": "Mira hacia el frente",
  "FaceTec_presession_remove_dark_glasses": "Retírate los lentes oscuros",
  "FaceTec_presession_neutral_expression": "Expresión neutra, sin sonreír",
  "FaceTec_presession_conditions_too_bright": "Demasiada luz",
  "FaceTec_presession_brighten_your_environment": "Ilumina su entorno",

  "FaceTec_feedback_center_face": "Centra tu rostro",
  "FaceTec_feedback_face_not_found": "Encuadra tu rostro",
  "FaceTec_feedback_move_phone_away": "Apártate",
  "FaceTec_feedback_move_away_web": "Apártate",
  "FaceTec_feedback_move_phone_closer": "Acércate",
  "FaceTec_feedback_move_web_closer": "Acerca la cara y rellena el óvalo",
  "FaceTec_feedback_move_web_even_closer": "Aún Más Cerca",
  "FaceTec_feedback_move_phone_to_eye_level": "Coloca la cámara a la altura de los ojos",
  "FaceTec_feedback_move_to_eye_level_web": "Mira directamente a la cámara",
  "FaceTec_feedback_face_not_looking_straight_ahead": "Mira hacia el frente",
  "FaceTec_feedback_face_not_upright": "Manten la cabeza recta",
  "FaceTec_feedback_face_not_upright_mobile": "Manten la cabeza recta",
  "FaceTec_feedback_hold_steady": "Mantente estable",
  "FaceTec_feedback_use_even_lighting": "Ilumina el rostro de forma más uniforme",

  "FaceTec_instructions_header_ready_desktop": "Prepárate para tu videoselfie",
  "FaceTec_instructions_header_ready_1_mobile": "Prepárate para",
  "FaceTec_instructions_header_ready_2_mobile": "tu videoselfie",
  "FaceTec_instructions_message_ready_desktop": "Encuadra tu rostro en el óvalo, presiona \"Estoy listo\" y acércate",
  "FaceTec_instructions_message_ready_1_mobile": "Encuadra tu rostro en el óvalo,",
  "FaceTec_instructions_message_ready_2_mobile": "presiona \"Estoy listo\" y acércate",

  "FaceTec_retry_header": "Inténtelo otra vez",
  "FaceTec_retry_subheader_message": "Necesitamos una videoselfie más clara",
  "FaceTec_retry_your_image_label": "Tu selfie",
  "FaceTec_retry_ideal_image_label": "Postura ideal",
  "FaceTec_retry_instruction_message_1": "Usar una postura e iluminación ideal",
  "FaceTec_retry_instruction_message_2": "Expresión neutra, sin sonreír",
  "FaceTec_retry_instruction_message_3": "Demasiado borrosa, limpie la cámara",

  "FaceTec_camera_feed_issue_header": "Problema al proteger la conexión de la cámara",
  "FaceTec_camera_feed_issue_header_mobile": "Problema al proteger<br/>la conexión de la cámara",
  "FaceTec_camera_feed_issue_subheader_message_mobile": "Esta aplicación bloquea configuraciones de cámara web sospechosas.<br/><a href='https://livenesscheckhelp.com/' target='_blank' style='text-decoration:underline; font:inherit; pointer-events:all;'>Aprende más aquí.</a>.",
  "FaceTec_camera_feed_issue_subheader_message": "No es posible continuar debido a lo siguiente:",
  "FaceTec_camera_feed_issue_table_header_1": "Posible Problema",
  "FaceTec_camera_feed_issue_table_header_2": "Corregir",
  "FaceTec_camera_feed_issue_table_row_1_cell_1_firefox_permissions_error": "Permisos de cámara no recordados en Firefox.",
  "FaceTec_camera_feed_issue_table_row_1_cell_2_firefox_permissions_error": "Marca Recordar Permisos.",
  "FaceTec_camera_feed_issue_table_row_1_cell_1": "Cámara ya en uso por otra aplicación.",
  "FaceTec_camera_feed_issue_table_row_1_cell_2": "Cierra la otra aplicación.",
  "FaceTec_camera_feed_issue_table_row_2_cell_1": "Una aplicación de terceros está modificando el video.",
  "FaceTec_camera_feed_issue_table_row_2_cell_2": "Cierre / desinstale la otra aplicación.",
  "FaceTec_camera_feed_issue_table_row_3_cell_1": "Equipos que no pueden ser protegidos.",
  "FaceTec_camera_feed_issue_table_row_3_cell_2": "Usa un dispositivo diferente.",
  "FaceTec_camera_feed_issue_subtable_message": "Esta aplicación bloquea configuraciones de cámara web sospechosas. <a href='https://livenesscheckhelp.com/' target='_blank' style='text-decoration:underline; font:inherit; pointer-events:all;'>Aprende más aquí.</a>.",
  "FaceTec_camera_feed_issue_action": "Intentar nuevamente",
  "FaceTec_camera_feed_issue_action_firefox_permissions_error": "Aceptar",

  "FaceTec_camera_permission_header": "Habilita la cámara",
  "FaceTec_camera_permission_message": "Permisos de cámara deshabilitados.<br/>Verifique la configuración de su sistema operativo y navegador",

  "FaceTec_enter_fullscreen_header": "Modo Selfie a Pantalla Completa",
  "FaceTec_enter_fullscreen_message": "Antes de comenzar, haga clic en el botón de abajo para abrir el modo de pantalla completa.",
  "FaceTec_enter_fullscreen_action": "Abrir pantalla completa",

  "FaceTec_initializing_camera": "Protegiendo la conexión",

  "FaceTec_idscan_type_selection_header": "Prepárese para escanear<br/>su identificación",
  "FaceTec_idscan_capture_id_front_instruction_message": "Anverso de su identificación",
  "FaceTec_idscan_capture_id_back_instruction_message": "Reverso de su identificación",
  "FaceTec_idscan_review_id_front_instruction_message": "Verifique sea nítida y legible",
  "FaceTec_idscan_review_id_back_instruction_message": "Verifique sea nítida y legible",
  "FaceTec_idscan_additional_review_message": "Se requiere<br/>una verificación adicional",
  "FaceTec_idscan_ocr_confirmation_main_header": "Revisar y confirmar",
  "FaceTec_idscan_ocr_confirmation_scroll_message": "Desplácese hacia abajo",
  "FaceTec_idscan_feedback_flip_id_to_back_message": "Reverso de su identificación",

  "FaceTec_result_success_message": "Listo",
  "FaceTec_result_facescan_upload_message": "Subiendo<br/>el escaneo facial 3D<br/>cifrado",
  "FaceTec_result_idscan_upload_message": "Subiendo<br/>el escaneo de identificación<br/>cifrado",
  "FaceTec_result_idscan_unsuccess_message": "La foto de la identificación<br/>o coincide con\el rostro del usuario",
  "FaceTec_result_idscan_success_front_side_message": "Escaneo de identificación completado",
  "FaceTec_result_idscan_success_front_side_back_next_message": "Anverso de la identificación<br/>escaneado",
  "FaceTec_result_idscan_success_back_side_message": "Escaneo de identificación completado",
  "FaceTec_result_idscan_success_passport_message": "Escaneo de pasaporte completado",
  "FaceTec_result_idscan_success_user_confirmation_message": "Escaneo de identificación con fotografía<br/>completado",
  "FaceTec_result_idscan_success_additional_review_message": "Captura de la fotografía de identificación<br/>completada",
  "FaceTec_result_idscan_retry_face_did_not_match_message": "El rostro no coincide<br/>lo suficiente",
  "FaceTec_result_idscan_retry_id_not_fully_visible_message": "La identificación<br/>no es totalmente visible",
  "FaceTec_result_idscan_retry_ocr_results_not_good_enough_message": "El texto de la identificación no es legible",
  "FaceTec_result_idscan_retry_id_type_not_suppported_message": "No se admite este tipo de identificación<br/>Utilice una identificación diferente",
  "FaceTec_result_idscan_retry_barcode_not_read_message": "No se pudo escanear el código de barras<br/>Inténtelo de nuevo",
};


